// src/flash/FlashLibrary.jsx
import React, { useMemo, useState } from "react";

const MOCK_FLASH = [
  {
    id: "scoops-01",
    title: "Scoops Ahoy",
    artist: "Beau",
    price: 100,
    tags: ["color", "fun"],
    thumbUrl: "/flash/scoops/thumb.png", // watermarked later
    imageUrl: "/flash/scoops/clean.png", // clean later
  },
  {
    id: "skull-01",
    title: "Skull",
    artist: "Shep",
    price: 150,
    tags: ["blackwork"],
    thumbUrl: "/flash/skull/thumb.png",
    imageUrl: "/flash/skull/clean.png",
  },
];

export default function FlashLibrary({ onSelectFlash }) {
  const [q, setQ] = useState("");

  const items = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return MOCK_FLASH;
    return MOCK_FLASH.filter((it) =>
      (it.title + " " + it.artist + " " + it.tags.join(" "))
        .toLowerCase()
        .includes(s)
    );
  }, [q]);

  return (
    <div style={{ padding: 12 }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search flash…"
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: 10,
            border: "1px solid rgba(255,255,255,0.15)",
            background: "rgba(0,0,0,0.25)",
            color: "white",
          }}
        />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: 10,
        }}
      >
        {items.map((it) => (
          <button
            key={it.id}
            onClick={() => onSelectFlash?.(it)}
            style={{
              textAlign: "left",
              padding: 0,
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 14,
              overflow: "hidden",
              background: "rgba(255,255,255,0.03)",
              cursor: "pointer",
            }}
          >
            <div style={{ aspectRatio: "1 / 1", width: "100%" }}>
              <img
                src={it.thumbUrl}
                alt={it.title}
                loading="lazy"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>

            <div style={{ padding: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: "white" }}>
                {it.title}
              </div>
              <div style={{ opacity: 0.8, fontSize: 12, color: "white" }}>
                {it.artist}{it.price ? ` • ${it.price}` : ""}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}